import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type Props = {
  isOpen: boolean;
  isLoading: boolean;
  rubricName: string | null;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ActivateRubricModal(props: Props) {
  const { isOpen, isLoading, rubricName, onConfirm, onCancel } = props;
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={props.onCancel}>
          {t("Reactivate rubric: {{ name }}?", { name: rubricName })}
        </DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            <Trans>
              By clicking “Reactivate rubric”, this rubric will be enabled again
              for use in scoring. Packages previously linked to this rubric will
              need to be manually reattached.
            </Trans>
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton
            size="medium"
            onPress={onCancel}
            testID="cancel-activate-button"
          >
            <Trans>Cancel</Trans>
          </BasicButton>
          <PrimaryButton
            type="submit"
            size="medium"
            isLoading={isLoading}
            onPress={() => onConfirm()}
            testID="activate-rubric-confirm-button"
          >
            <Trans>Reactivate rubric</Trans>
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
